type FunnelLayoutProps = {
  children: React.ReactNode;
  className?: string;
};

export default function FunnelLayout({ children, className = '' }: FunnelLayoutProps) {
  return (
    <div className={`flex min-h-screen flex-col bg-bg-primary text-fg-primary ${className}`}>
      {children}
    </div>
  );
}
